export const ToolsPage = () => {
  return (
    <div className="h-full flex items-center justify-center bg-surface">
      <h1 className="text-2xl font-semibold text-primary">Em breve</h1>
    </div>
  );
};